import { useCurrentLanguage } from '@aikoa/i18n/react'
import DateTimePicker, { useDefaultClassNames, type DateType } from 'react-native-ui-datepicker'
import Icon from '~/components/Icon'
import { getDateFromDateType } from '~/lib/dateType'
import { cn } from '~/lib/utils'

type CalendarProps = {
  date?: Date
  onChange: (date: Date) => void
  timePicker?: boolean
  minDate?: Date
  maxDate?: Date
}

export function Calendar({ date, onChange, timePicker = false, minDate, maxDate }: CalendarProps) {
  const defaultStyles = useDefaultClassNames()

  const handleChange = ({ date: newDate }: { date: DateType }) => {
    const nextDate = getDateFromDateType(newDate)

    if (nextDate) {
      onChange(nextDate)
    }
  }

  const language = useCurrentLanguage()

  return (
    <DateTimePicker
      mode="single"
      date={date}
      onChange={handleChange}
      maxDate={maxDate}
      minDate={minDate}
      classNames={{
        ...defaultStyles,
        weekday_label: cn(defaultStyles.weekday_label, 'font-light text-foreground'),
        header: cn(defaultStyles.header, 'justify-between'),
        day_cell: cn(defaultStyles.day_cell, 'p-1'),
        day: cn(
          defaultStyles.day,
          'group/day hover:bg-transparent! rounded-lg border border-transparent transition-all duration-150 hover:border-secondary'
        ),
        day_label: cn(
          defaultStyles.day_label,
          'transition-all duration-100 group-hover/day:text-accent-foreground group-hover/day:text-primary'
        ),
        selected: cn(defaultStyles.selected, 'bg-accent hover:border-transparent hover:!bg-accent'),
        selected_label: cn(
          defaultStyles.selected_label,
          'text-accent-foreground group-hover/day:text-accent-foreground'
        ),
        today: cn(defaultStyles.today, 'bg-muted'),
        today_label: cn(defaultStyles.today_label, 'text-foreground'),
        disabled: cn(defaultStyles.disabled, 'pointer-events-none bg-transparent'),
        disabled_label: cn(
          defaultStyles.disabled_label,
          'pointer-events-none text-muted-foreground'
        ),
      }}
      timePicker={timePicker}
      locale={language}
      components={{
        IconNext: <Icon name="chevron-forward" size={20} className="text-foreground" />,
        IconPrev: <Icon name="chevron-back" size={20} className="text-foreground" />,
      }}
    />
  )
}
